// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"d33cb06138c758d4","741":"7784b392d1663adb"}[chunkId] + ".js";
};